import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
//eslint-disable-next-line
import { SectionHeading as HeadingBase } from "components/misc/Headings";
import { SectionDescription as DescriptionBase } from "components/misc/Typography";
import { ReactComponent as SvgDotPattern } from "images/dot-pattern.svg"

// const Column = tw.div`flex-1`;
// const TextColumn = tw(Column)`mx-auto lg:mr-0 max-w-2xl lg:max-w-xl xl:max-w-2xl flex-shrink-0`;
const Heading = tw(HeadingBase)`text-center lg:text-left text-primary-900 leading-snug`;
const Description = tw(
  DescriptionBase
)`mt-4 text-center lg:text-left lg:text-base text-gray-700 max-w-lg mx-auto lg:mx-0`;
// const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto md:py-2 items-center`;
// const ImageColumn = tw(Column)`md:w-6/12 mx-12 flex-shrink-0 relative`;
const Image = styled.img(props => [
  props.imageRounded && tw`rounded`,
  props.imageBorder && tw`border`,
  props.imageShadow && tw`shadow`,
]);
const TwoColumn = tw.div`flex flex-col lg:flex-row justify-between items-center py-2 max-w-screen-xl mx-auto gap-8 lg:gap-12`;
const Column = tw.div`w-full mx-auto lg:mx-0`;
const ImageColumn = styled(Column)(props => [
  tw`w-full lg:w-5/12 flex-shrink-0 flex-grow-0 relative block`
]);
const TextColumn = styled(Column)(props => [
  tw`w-full lg:w-7/12 mt-12 lg:mt-0`,
  props.textOnLeft ? tw`lg:mr-4 xl:mr-8 lg:order-first` : tw`lg:ml-4 xl:ml-8 lg:order-last`
]);
const TextContent = tw.div`lg:py-8 text-center md:text-left`;
const DecoratorBlob = styled(SvgDotPattern)(props => [
  tw`w-20 h-20 absolute right-0 bottom-0 transform translate-x-1/2 translate-y-1/2 fill-current text-primary-500 -z-10`,
]);


export default ({
  heading = "Modern React Templates, Just For You",
  description = "Our templates are easy to setup, understand and customize. Fully modular components with a variety of pages and components.",
  imageSrc = "",
  imageRounded = true,
  imageBorder = false,
  imageShadow = false,
  imageCss = null,
  imageDecoratorBlob = false,
  imageDecoratorBlobCss = null,
}) => {

  return (
    <>
        <TwoColumn>
          <ImageColumn>
          <div tw="w-full h-auto block relative">
            <img
              src={imageSrc}
              alt="Ilustración"
              tw="w-full h-auto object-contain block mx-auto"
            />
          </div>
            {/* <Image css={imageCss} src={imageSrc} imageBorder={imageBorder} imageShadow={imageShadow} imageRounded={imageRounded} /> */}
            {imageDecoratorBlob && <DecoratorBlob css={imageDecoratorBlobCss} />}
          </ImageColumn>
          <TextColumn textOnLeft={true}>
            <TextContent>
              {/* <Subheading>{subheading}</Subheading> */}
              <Heading>{heading}</Heading>
              <Description>{description}</Description>
            </TextContent>
          </TextColumn>
        </TwoColumn>
    </>
  );
};
